module.exports = __webpack_public_path__ + "img/concreted_default.ab5717f3.png";